<template>
    <div class="white-table">
        <table>
            <thead>
                <tr v-if="!customth">
                    <th v-for="(label, index) in labels" :key="`simple-table-header-${index}`">{{ label }}</th>
                    <th><slot name="table-actions"></slot></th>
                </tr>
                <slot name="table-header"></slot>
            </thead>

            <tbody>
                <slot name="table-data"></slot>
            </tbody>
        </table>

        <div v-if="showSelectAll" class="select-all"> <input id="test" type="checkbox" @click="selectAll($event)"/><label for="test">{{selectLabel}}</label></div>


        <div v-if="showPaginate" class="paginate" style="display:flex;">
            <button class="left-arrow" :disabled="paginate.current_page === 1" :class="{'disabled': paginate.current_page === 1 }" @click="changePageNumber('previous')" > <i class="fal fa-chevron-left"></i> </button>

            <div class="page-number" style="display: flex;" >
                <div class="current-page-number" >
                    <input
                        type="text"
                        @key="pageNumber"
                        @keydown="pageNumber"
                        v-model.number="paginate.current_page"
                        :disabled="(paginate.current_page === paginate.last_page && paginate.current_page === 1 )"
                    />
                </div>
                <div class="total-page-number">
                    <span > / {{paginate.last_page}}</span>
                </div>

            </div>

            <button class="right-arrow" :disabled="paginate.current_page === paginate.last_page" :class="{'disabled': paginate.current_page === paginate.last_page }" @click="changePageNumber('next')"> <i class="fal fa-chevron-right"></i> </button>

        </div>

    </div>
</template>

<script>
import debounce from 'lodash/debounce';

export default {
    name: 'WhiteTable',

    props: {
        labels: {
            type: Array,
            default: () => [],
        },
        showSelectAll: {
            type: Boolean,
            default: false,
        },
        selectLabel: {
            type: String,
        },

        customth: {
            type: Boolean,
            default: false,
        },

        paginate: {
            type: Object,
            required: false,
        },

        showPaginate: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    methods: {
        selectAll(event) {
            this.$emit('selectEverything', event.target.checked);
        },
        changePageNumber(value) {
            this.$emit('changePage', value);
        },
        // eslint-disable-next-line
        pageNumber: debounce(function(event) {
            if (this.paginate.current_page > this.paginate.last_page) {
                this.paginate.current_page = this.paginate.last_page;
            }
            this.$emit('changePage', this.paginate.current_page);
        }, 500),
    },
};
</script>
<style lang="scss" scoped>
.white-table {
    width: 100%;
    position: relative;

    table {
        width: 100%;
        border-spacing: 0 4px;

        thead {
            th {
                text-align: left;
                padding: 4px 10px;
                font-weight: bold;
            }
        }

        tbody {
            tr {
                margin-bottom: 8px;

                td {
                    text-align: left;
                    padding: 10px;
                    background-color: white;

                    i {
                        margin-left: 5px;
                        margin-right: 5px;
                        cursor: pointer;
                        color: #5F7A93;
                        font-size: 20px;

                        &.red {
                            color: #fe1818;
                        }

                        &.yellow {
                            color: #fecb18;
                        }
                    }

                    &.align-right {
                        text-align: right;
                    }

                    &:first-child {
                        border-top-left-radius: 4px;
                        border-bottom-left-radius: 4px;
                    }

                    &:last-child {
                        border-top-right-radius: 4px;
                        border-bottom-right-radius: 4px;
                    }
                }
            }
        }
    }
    div.select-all {
        padding: 4px 16px;
    }

    // Paginate
    .left-arrow , .right-arrow {
        width:30px;
        height:40px;
        background: $yellow;
        border-radius: 5px;
        cursor: pointer;

        i {
            // padding:12px;
            color:white;
            font-size:16px;
        }
    }

    .left-arrow.disabled, .right-arrow.disabled {
        background: #5F7A93;
        cursor: not-allowed;
    }

    .page-number {
        margin: 0 10px;
        input {
            text-align: center;
            height:40px;
            width:50px;
            border: 1px solid $yellow;
            border-radius: 5px;
        }
        .total-page-number {
            padding-top:10px;
        }
    }

    .total-page-number {
        margin-left:10px;
    }
}


</style>
